import { IsBoolean, IsNotEmpty, IsUUID } from 'class-validator';
import { BaseCreateDto, BaseDto } from '../base.dto';

/**
 * Base consent structure used to build more specific consent DTOs.
 */
export interface BaseConsentDto {
  consented: boolean;
  consentRevisionId: string;
  consentId?: string;
}

export interface HealthRecordConsentDto extends BaseDto, BaseConsentDto {
  healthRecordId: string;
}

export class CreateHealthRecordConsentDto
  extends BaseCreateDto
  implements Partial<HealthRecordConsentDto>
{
  @IsNotEmpty()
  @IsBoolean()
  consented: boolean;

  @IsNotEmpty()
  @IsUUID()
  consentRevisionId: string;

  @IsNotEmpty()
  @IsUUID()
  healthRecordId: string;
}
